export const ORDER_STATUS_LABELS = {
  new: 'Новый',
  reserved: 'В резерве',
  paid: 'Оплачен',
  assembling: 'Сборка',
  shipped: 'Отправлен',
  delivered: 'Доставлен',
  completed: 'Завершён',
  cancelled: 'Отменён',
};

export const ORDER_STATUS_TRANSITIONS = {
  new: ['cancelled', 'paid', 'assembling'],
  reserved: ['cancelled', 'paid'],
  paid: ['assembling', 'cancelled'],
  assembling: ['shipped', 'delivered', 'cancelled'],
  shipped: ['delivered', 'cancelled'],
  delivered: ['completed'],
  completed: [],
  cancelled: [],
};

export function labelOrderStatus(status) {
  const key = String(status || '').toLowerCase();
  return ORDER_STATUS_LABELS[key] || (status ? String(status) : 'Новый');
}

export function nextOrderStatuses(status) {
  return ORDER_STATUS_TRANSITIONS[String(status || '')] || [];
}

/** Customer-facing label: combine order + payment */
export function labelCustomerOrder(order) {
  const st = String(order?.status || '').toLowerCase();
  const pay = String(order?.payment?.status || '').toLowerCase();

  if (st === 'cancelled' || pay === 'cancelled' || pay === 'failed') return 'Отменён';
  if (st === 'delivered' || st === 'completed') return 'Доставлен';
  if (st === 'shipped') return 'Отправлен';
  if (st === 'assembling') return 'Собираем';
  if (st === 'paid' || pay === 'paid') return 'Оплачен';
  if (st === 'reserved' || pay === 'pending') return 'Ожидает оплаты';
  return 'Новый';
}
